function obEstepaNestedItems(form, formData) {
  const marker = form.querySelector('[data-estepa-additional-item]');
  if (!marker) return null;
  const productId = form.closest('product-info')?.dataset.productId;
  const addonId = marker.getAttribute('data-variant-id');
  const columnId = '57822309384536';
  const allowed = productId === '15900687040856'
    ? [columnId, '57823392596312', '57823415828824', '57822398087512']
    : ['15906251833688', '15906916925784', '15907106259288'].includes(productId) ? [columnId] : [];
  if (!allowed.includes(addonId)) return null;
  // The native add-on must be unlinked first. Never charge both paths.
  if (formData.getAll('properties[_io_product_bundle_ids]').some(value =>
    !/^(?:\[\s*\]|\{\s*\}|null|false|0)?$/.test(String(value).trim())
  )) return null;
  const parentId = String(formData.get('id') || '');
  const quantity = Number(formData.get('quantity') || 1);
  if (!/^\d+$/.test(parentId) || !Number.isInteger(quantity) || quantity <= 0) return null;
  const properties = {};
  for (const [key, value] of formData) {
    const property = /^properties\[(.+)\]$/.exec(key);
    if (!property || ['_io_product_bundle_ids', '_io_properties'].includes(property[1])) continue;
    if (typeof value !== 'string') return null;
    properties[property[1]] = value;
  }
  const parent = { id: parentId, quantity, properties };
  const sellingPlan = formData.get('selling_plan');
  if (sellingPlan) parent.selling_plan = sellingPlan;
  return [parent, { id: addonId, parent_id: parentId, quantity }];
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        this.form.dispatchEvent(new Event('ob:estepa:sync', { bubbles: true }));
        const formData = new FormData(this.form);
        const estepaItems = obEstepaNestedItems(this.form, formData);
        const quickAddModal = this.closest('quick-add-modal');
        const columnSelect = quickAddModal?.querySelector('[data-ob-quick-column]');
        const columnVariantId = columnSelect?.value;
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (columnVariantId) {
          const columnLabel = columnSelect.selectedOptions[0]?.dataset.label || 'Columna auxiliar FLORENCIA';
          const quantity = Number(formData.get('quantity') || 1);
          const productProperties = {};

          formData.forEach((value, key) => {
            const propertyMatch = key.match(/^properties\[(.+)\]$/);
            if (propertyMatch && value) productProperties[propertyMatch[1]] = value;
          });
          productProperties['Columna auxiliar'] = columnLabel;

          const productItem = {
            id: String(formData.get('id')),
            quantity,
            properties: productProperties,
          };
          const sellingPlan = formData.get('selling_plan');
          if (sellingPlan) productItem.selling_plan = sellingPlan;

          const requestBody = {
            items: [
              productItem,
              {
                id: String(columnVariantId),
                quantity,
                properties: { _Complemento: 'Columna auxiliar FLORENCIA' },
              },
            ],
          };

          if (this.cart) {
            requestBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
            requestBody.sections_url = window.location.pathname;
          }

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(requestBody);
        } else if (estepaItems) {
          const requestBody = { items: estepaItems };
          if (this.cart) {
            requestBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
            requestBody.sections_url = window.location.pathname;
          }
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(requestBody);
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'ob_cart_error',
                variant_id: formData.get('id'),
                message: response.errors || response.description || response.message,
              });
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'ob_add_to_cart_success',
              variant_id: formData.get('id'),
              quantity: Number(formData.get('quantity') || 1),
            });
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(window.cartStrings.error);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'ob_cart_error', type: 'network', message: e.message });
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

